/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-2024 (original work) Open Assessment Technologies SA ;
 */

/**
 * Keys for settings.
 * Used not only by settings plugin, but in others as well.
 * Should remain a flat list, even if certain entries (e.g. readAloud*, a11y tools)
 * may occur in nested objects elsewhere.
 */
export default {
    choiceElimination: 'choiceElimination',
    choiceAnswerMasking: 'choiceAnswerMasking',
    readAloud: 'readAloud',
    readAloudVoice: 'voice',
    readAloudSpeed: 'speed',
    readAloudPitch: 'pitch',
    pageZoom: 'pageZoom',
    contrastTheme: 'contrastTheme',
    mousePointer: 'mousePointer',
    fontFamily: 'fontFamily',
    fontSize: 'fontSize',
    lineHeight: 'lineHeight',
    letterSpacing: 'letterSpacing',
    wordSpacing: 'wordSpacing',
    letterAndWordSpacing: 'letterAndWordSpacing',
    a11yMenuPanel: 'a11yMenuPanel'
};
